import Skeleton from './Skeleton';

/**
 * Table-shaped skeleton.
 * @param {number} rows    - Number of rows (default 5)
 * @param {number} columns - Number of columns (default 4)
 */
const TableSkeleton = ({ rows = 5, columns = 4 }) => (
  <div className="skeleton-table">
    {/* Header */}
    <div className="skeleton-table__row" style={{ paddingBottom: '0.75rem', marginBottom: '0.25rem' }}>
      {Array.from({ length: columns }).map((_, i) => (
        <Skeleton key={`h-${i}`} height={12} width={i === 0 ? '30%' : '18%'} />
      ))}
    </div>
    {/* Body rows */}
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="skeleton-table__row">
        {Array.from({ length: columns }).map((_, c) => (
          <Skeleton key={`${r}-${c}`} height={10} width={c === 0 ? '35%' : `${14 + (c * 4)}%`} />
        ))}
      </div>
    ))}
  </div>
);

export default TableSkeleton;
